export default "__VITE_ASSET__9e109b14__"